<template>
  <BaseButton
    v-if="ssoStore.isAvailable"
    color="accent"
    @click="toggleLogin"
  >
    {{ buttonText }}
  </BaseButton>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { useSsoStore } from '@/stores/sso';

  import BaseButton from '../ui/BaseButton.vue';

  const { t: $t } = useI18n();
  const ssoStore = useSsoStore();

  const buttonText = computed(() => ssoStore.isLoggedIn ? $t('globals.sso_logout') : $t('globals.sso_login'));

  function toggleLogin() {
    if (ssoStore.isLoggedIn) {
      ssoStore.logout();
    } else {
      ssoStore.login();
    }
  }
</script>
